/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import store, { persistor } from "./app/store/store";
import App from './App';
import { setupAxios } from "./_metronic";
// import "./sass/style.react.rtl.css"; // RTL version
// IE 11 polyfills
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
// Fonts
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// GraphQL
import { ApolloProvider } from '@apollo/react-hooks';
import ApolloClient from 'apollo-boost';
import { Mutation } from "react-apollo";
import "./index.scss"; // Standard version


const { PUBLIC_URL, REACT_APP_GRAPHQL_URL } = process.env;

/**
 * Setup REST
 */
setupAxios(axios, store);

/**
 * Setup graphQL
 */
const graphqlClient = new ApolloClient({
    uri: REACT_APP_GRAPHQL_URL,
    request: (operation) => {

        const {
            auth: { authToken }
        } = store.getState();

        if(authToken) {
            operation.setContext({
                headers: {
                    'X-Auth-Token': `${authToken}`
                }
            })
        }
    },
    onError: (error) => {
        console.log("Erro", error);
        if(error && error.networkError && error.networkError.statusCode == 403) {
            document.location=PUBLIC_URL + "/logout";
        }
    }
});

/* Método de limpeza para envio do objeto para salvar */
Mutation.cleanupData = (obj, level = null) => {
    if(!level)
        level = 0;

    if(!obj) return null;

    obj = JSON.parse(JSON.stringify(obj));
    if (obj.__typename) {
        delete obj.__typename;
    }

    // Referencias para outros objetos devem ter apenas o ID
    if(level > 0) {
        Object.keys(obj).forEach(k => {
            if(k !== "id")
                delete obj[k];
        });
    }

    Object.keys(obj).forEach(k => {
        if(Array.isArray(obj[k])) {
            obj[k] = obj[k].map( item => Mutation.cleanupData(item, 0) );
        } else if (typeof obj[k] === "object") {
            obj[k] = Mutation.cleanupData(obj[k], level + 1);
        }
    });
    return obj;
}

const Layout = React.lazy(() =>
  import("./_metronic/layout/Layout.js")
);

ReactDOM.render(
    <ApolloProvider client={graphqlClient}>
        <App
          store={store}
          Layout={Layout}
          persistor={persistor}
          basename={PUBLIC_URL}
        />
    </ApolloProvider>,
  document.getElementById("root")
);
